export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/mr.6a9f9854.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};